import {
  CAP_MAXIMUMS,
  type CapKey,
  type JiraSettingsForm,
} from "./jiraSettings";

/** The numeric caps this card edits. */
export type Caps = Pick<JiraSettingsForm, CapKey>;

const NUMBER_FIELDS = [
  {
    key: "max_issues_per_query",
    label: "Max issues per query",
    hint: "Fetched 100 per page; the rest sets truncated.",
  },
  {
    key: "per_user_queries_per_hour",
    label: "Queries per user per hour",
    hint: "Cache hits count too.",
  },
  {
    key: "default_cache_ttl_seconds_cap",
    label: "Cache TTL cap (seconds)",
    hint: "Longest window an artifact may request.",
  },
] as const;

/** The three numeric caps, with a hint under each value the backend would reject. */
export function JiraCapsFields({
  caps,
  invalid,
  onChange,
}: {
  caps: Caps;
  invalid: CapKey[];
  onChange: (caps: Caps) => void;
}) {
  return (
    <div className="grid gap-3 rounded-lg border border-slate-200 bg-white p-4">
      {NUMBER_FIELDS.map((f) => {
        const max = CAP_MAXIMUMS[f.key];
        return (
          <label
            key={f.key}
            className="flex items-center justify-between gap-4 text-sm"
          >
            <span>
              {f.label}
              <span className="block text-xs text-slate-500">{f.hint}</span>
              {invalid.includes(f.key) && (
                <span className="block text-xs text-rose-700">
                  {max === null
                    ? "A whole number of 1 or more."
                    : `A whole number from 1 to ${max}.`}
                </span>
              )}
            </span>
            <input
              type="number"
              min={1}
              max={max ?? undefined}
              step={1}
              value={Number.isNaN(caps[f.key]) ? "" : caps[f.key]}
              onChange={(e) => {
                const next = { ...caps };
                // NaN while blank, so the field can be cleared and retyped;
                // invalidCaps keeps Save disabled until it holds a valid number.
                next[f.key] =
                  e.target.value === "" ? Number.NaN : Number(e.target.value);
                onChange(next);
              }}
              className="w-28 rounded-md border border-slate-300 px-2 py-1 text-right text-sm"
            />
          </label>
        );
      })}
    </div>
  );
}
